import apiUrl from '../../../constants';
import axios from 'axios';
import Paginate from 'vuejs-paginate';
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import Pagination from './../shared/pagination'
import Loader from './../shared/loader'

export default {
	name: 'ProductCategory',
	components: {
		Paginate,
		Loader,
		DatePicker,
		Pagination
	},
	data: function() {
		return {
			// totalRows:0,
			totalPage: 0,
			totalRows:0,
			resultCount:0,
			currentPage: 1,
			pageLimit:10,
			client: '',
			searchchannel: '',
			listClientData: [],
			channellist: [],
			// currentPage: 0,
			// totalPage: 0,
			// pageNo: 0,
			// pageLimit: 10,
			addcouriermodal: false,
			courieraction: '',
			clientid: '',
			clientidErr: '',
			ClientErr: '',
			channellistmodal: [],
			searchchannelmodal: '',
			transporterList: [],
			transporter: '',
			searchchannelmodalerr: '',
			transportererr: '',
			isLoading: false,
			isLoadingm: false,
			deletemodal: false,
			listcourierData: [],
			statusmodalShow: false,
			statusdata: {},
			deletedata: {},
			editdata: {},

		}
	},

	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		},
		capitalize: function(value) {
			if (!value) return ''
			value = value.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		}
	},

	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.user_type = userdetail.utype;
		this.getClientList();
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getSalesChannels()
		this.getTransporterList();
		}
		
	},

	methods: {
		getClientList() {
			this.pageNo = this.totalPage = 0;
			if (window.localStorage.getItem("clientList") !== null) {
				var clientListEncrypt = window.localStorage.getItem('clientList');
				var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
				var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
				this.listClientData = JSON.parse(plaintextclient);
			} else {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': {},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listClientData = result.data.data;
				}, error => {
					console.error(error);
				});
			}
		},

		getTransporterList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'courierMasterList',
					'data': {
						clientid: window.localStorage.getItem("selectedClient")

					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.transporterList = result.data.data.rows;
				}, error => {
					console.error(error)
				})
		},

		clientSelected() {
			this.totalRows=0;
			this.pageNo = 0;
			this.currentPage = 1;
			this.totalPage = 0;
			this.pageLimit = 10;
			this.channellist = [];
			this.searchchannel = '';
			this.listcourierData = [];
			if (this.client) {
				this.getSalesChannels()
			}
		},
		clearform() {
			this.pageNo = 0;
			this.currentPage = 1;
			this.totalPage = 0;
			this.pageLimit = 10;
			this.channellist = [];
			this.searchchannel = '';
			this.listcourierData = [];
		},
		clientidSelected() {
			this.searchchannelmodal = '';
			this.transporter = '';
			this.channellistmodal = []
			if (this.clientid) {
				this.getSalesChannelsmodel()
				this.getTransporterList()
			}
		},

		addNewcouriermap() {
			this.clientidErr = "";
			this.searchchannelmodalerr = "";
			this.transportererr = "";
			this.clientid = window.localStorage.getItem("selectedClient");
			this.searchchannelmodal = '';
			this.channellistmodal = [];
			this.transporter = '';
			this.courieraction = 'add';
			this.addcouriermodal = true;
		},

		closecourierModal() {
			document.getElementById("searchchannelmodal").value = "";
			this.editdata = {};
			this.clientidErr = "";
			this.searchchannelmodalerr = "";
			this.transportererr = "";
			this.clientid = '';
			this.searchchannelmodal = '';
			this.channellistmodal = [];
			this.transporter = '';
			this.addcouriermodal = false;
		},
		editcourier() {
			if (localStorage.getItem("selectedClient") == "") {
				this.clientidErr = this.$t('common.clientError')
				return false;
			}

			if (this.searchchannelmodal == "") {
				this.searchchannelmodalerr = this.$t('courierMapping.salesChannelError')
				return false;
			}
			if (this.transporter == "") {
				this.transportererr = this.$t('courierMapping.transportererr')
				return false;
			}
			this.isLoadingm = true;
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateCouriermappinglist',
					'data': {
						clientid: localStorage.getItem("selectedClient"),
						saleschannel: this.searchchannelmodal,
						transporter: this.transporter,
						transporterold: this.editdata.couriercompany,
						saleschannelold: this.editdata.saleschannel
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.isLoadingm = false;
					if (result.data.errorCode == 0) {
						this.editdata = {};
						this.addcouriermodal = false;
						this.$alertify.success(this.$t('courierMapping.connectionUpdated'));
						this.getcouriermappingData(1);
					} else {
						this.$alertify.error(result.data.msg);
						return false;
					}
				}, error => {
					console.error(error);
				});
		},
		savecourier() {
			if (localStorage.getItem("selectedClient") == "") {
				this.clientidErr = this.$t('common.clientError')
				return false;
			}

			if (this.searchchannelmodal == "") {
				this.searchchannelmodalerr = this.$t('courierMapping.salesChannelError')
				return false;
			}
			if (this.transporter == "") {
				this.transportererr = this.$t('courierMapping.transportererr')
				return false;
			}
			this.isLoadingm = true;
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'addCouriermappinglist',
					'data': {
						clientid: localStorage.getItem("selectedClient"),
						saleschannel: this.searchchannelmodal,
						transporter: this.transporter,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.isLoadingm = false;
					if (result.data.errorCode == 0) {
						this.addcouriermodal = false;
						this.$alertify.success(this.$t('courierMapping.connectionCreated'));
						this.getcouriermappingData(1);
					} else {
						this.$alertify.error(result.data.msg);
						return false;
					}
				}, error => {
					console.error(error);
				});
		},
		getcourierRowData(data) {
			this.clientid = data.clientid;
			if (this.clientid) {
				this.getSalesChannelsmodel()
			}
			this.editdata = data;
			this.channellistmodal = [];
			this.clientidErr = "";
			this.searchchannelmodalerr = "";
			this.transportererr = "";
			this.searchchannelmodal = data.saleschannel;
			document.getElementById("searchchannelmodal").value = data.saleschannel;
			this.transporter = data.couriercompany;
			this.addcouriermodal = true;
			this.addcouriermodal = true;
			this.courieraction = 'edit';
		},

		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'orderSalesChannelList',
					'data': {
						clientid: localStorage.getItem("selectedClient")
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},

		deleteconnectionmodal(data) {
			this.deletedata = data;
			this.deletemodal = true;
		},
		closedeletemodal() {
			this.deletedata = {};
			this.deletemodal = false;
		},
		daletesonnection() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'deleteCouriermappinglist',
					'data': {
						clientid: localStorage.getItem("selectedClient"),
						saleschannel: this.deletedata.saleschannel,
						transporter: this.deletedata.couriercompany,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.errorCode == 0) {
						this.deletedata = {};
						this.deletemodal = false;
						this.$alertify.success(this.$t('courierMapping.connectionDeleted'));
						this.getcouriermappingData();
					} else {
						this.$alertify.error(this.$t('courierMapping.connectionNotDeleted'));
					}
				}, error => {
					console.error(error);
				});
		},
		closeStatusModal() {
			this.statusmodalShow = false;
			this.statusdata = {};
		},
		changestatus() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.statusdata.status == 1) {
				var status = 0
			} else {
				var status = 1
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'changestatusCouriercompany',
					'data': {
						clientid: this.statusdata.clientid,
						saleschannel: this.statusdata.saleschannel,
						transporter: this.statusdata.couriercompany,
						status: status
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.errorCode == 0) {
						this.statusdata = {};
						this.statusmodalShow = false;
						this.$alertify.success(this.$t('courierMapping.statusUpdated'));
						this.getcouriermappingData();
					} else {
						this.$alertify.error(this.$t('courierMapping.statusNotUpdated'));
					}
				}, error => {
					console.error(error);
				});
		},
		getStatusRowData(data) {
			this.statusdata = {};
			this.statusmodalShow = true;
			this.statusdata = data;
		},
		getSalesChannelsmodel() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'orderSalesChannelList',
					'data': {
						clientid: this.clientid
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.channellistmodal = result.data.data;
				}, error => {
					console.error(error);
				});
		},

		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.pageLimit;
		// 	this.getcouriermappingData();
		// },
		onPageChange(page) {
		  this.currentPage = page;
		  this.getcouriermappingData()
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		getcouriermappingSearch(check){
			this.currentPage = 1;
			this.getcouriermappingData(check);
		},
		getcouriermappingData(check) {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}
			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getCouriermappinglist',
					'data': {
						'clientid': localStorage.getItem("selectedClient"),
						'saleschannel': this.searchchannel.trim(),
						'offset': (this.currentPage - 1) * 10,
						'limit': this.pageLimit
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					this.isLoading = false;
					if (response.data.errorCode == 0) {
						this.listcourierData = response.data.data
						this.listcourierData = response.data.data;
						this.totalRows = response.data.count
						this.resultCount = response.data.count
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit)
						}
					} else {
							this.resultCount = response.data.count
						this.listcourierData = []
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		resetForm() {
			this.totalRows=0;
			this.pageNo = 0;
			this.resultCount=0;
			this.currentPage = 0;
			this.totalPage = 0;
			this.pageLimit = 10;
			// this.channellist = [];
			// this.client = "";
			this.searchchannel;
			this.listcourierData = [];
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/couriermapping/couriermapping.component.js